LS.util.route({
	'advertise': {
		':load': 'advertise',
		':unload': 'advertise:unload'
	}
});